import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import Breadcrumbs from './../block/Breadcrumbs'

import { Container, Image, Button } from 'react-bootstrap'

import styles from './../style/Korzina.module.scss'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      recomended: [],
      loading: true
    }
  }

  loadRecomended = () => {
    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this

    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'load_products_ng',
      'variant': `rend`,
      'page': 1
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        recomended: response.data.products
      })
    })
  }

  componentDidMount() {
    const { ajax_data } = this.props

    if('yookassa_url' in ajax_data) {
      if(!ajax_data?.no_redirect) window.location.href = ajax_data.yookassa_url
    }

    this.setState({
      loading: false
    })
    this.loadRecomended()
  }

  render() {

    const { ajax_data, data, showInCart, favorite, changeFavorite, cart, in_cart_loading } = this.props,
    { recomended, loading } = this.state

    if (loading) {
      return (
        <>
          <div className='w-100 d-flex align-items-center' style={{ flex: 1 }}>
            <div className="container text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <p className="mt-3">Загрузка данных...</p>
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null &&
            <>
              <Breadcrumbs
                items={ajax_data.breadcrumbs}
              />
              <div className={styles.oformlen_page}>
                <Container className={styles.container}>
                  <h1>Оформление заказа</h1>
                  {ajax_data.order != null ?
                    <> 
                      <div className={styles.oformlen_page_str}>Поздравляем! Вы успешно оформили заказ</div>
                      <div className={styles.oformlen_page_str}>Спасибо за Ваш заказ, менеджер свяжется с Вами оперативно</div>
                      <div className={styles.oformlen_page_ostr}>Номер вашего заказа № {ajax_data.order}</div>
                    </>
                  :
                    <>
                      <div className={styles.oformlen_page_ostr}>Заказ с таким номером не найден!</div>
                    </>
                  }
                  <div className='w-100 d-flex justify-content-center'>
                    {'yookassa_url' in ajax_data ?
                      <Button href={ajax_data.yookassa_url} className={styles.oformlen_page_ostr_btn} variant='dark'>Перейти к оплате</Button>
                    :
                      <Button href={'/'} className={styles.oformlen_page_ostr_btn} variant='dark'>На главную</Button>
                    }
                  </div>
                </Container>
              </div>
            </>
          }
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  data: PropTypes.object
}